import { useSyncExternalStore } from 'react';

function getSnapshot() {
  return typeof document !== 'undefined' && document.visibilityState === 'visible';
}

function subscribe(callback: VoidFunction) {
  window.addEventListener('visibilitychange', callback);

  return () => {
    window.removeEventListener('visibilitychange', callback);
  };
}

export function useIsDocumentActive() {
  return useSyncExternalStore(subscribe, getSnapshot);
}
